import { registerApp } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { initI18n, getDomain } from 'utils';
import { createEntry, getInitialData } from '../common';

const store = getInitialData();
const router = getGlobalRouter();

if (store.isBot === false) {
  const domain = getDomain(store.host);
  initI18n(router.getPath(), domain);

  registerApp(__NAME__, () => {
    return createEntry({ router, store, remoteContext: undefined });
  });
}
